// src/app/shared/formly-primeng/input/input.type.ts
import { Component, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormControl } from '@angular/forms';
import { FieldType, FormlyFieldConfig, FormlyModule } from '@ngx-formly/core';
import { InputTextModule } from 'primeng/inputtext';

interface InputProps {
  type?: string;
  placeholder?: string;
}

@Component({
  selector: 'formly-field-primeng-input',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormlyModule,
    InputTextModule
  ],
  template: `
    <input
      pInputText
      [id]="id"
      [type]="props.type || 'text'"
      [formControl]="inputControl"
      [formlyAttributes]="field"
      [placeholder]="props.placeholder || ''"
      class="w-full"
      [class.ng-dirty]="showError"
      [class.ng-invalid]="showError"
    />
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FormlyFieldInput extends FieldType<FormlyFieldConfig<InputProps>> {
  get inputControl() {
    return this.formControl as FormControl;
  }
}